import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import ThinClientOverviewContextProvider from "./context/ThinClientOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {THIN_CLIENTS} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class ThinClientPage extends Component {
    render() {
        return (
            <Column>
                <ThinClientOverviewContextProvider>
                    <TabLayout routes={THIN_CLIENTS} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={THIN_CLIENTS}/>
                </ThinClientOverviewContextProvider>
            </Column>
        )
    }
}

export default ThinClientPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/ThinClientPage.js